import { normalizeCompanyPreferences } from './companyPreferences';

export const COMPANY_PREFERENCES_STORAGE_KEY = 'company_preferences';

function readAllPreferences() {
  try {
    const raw = localStorage.getItem(COMPANY_PREFERENCES_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
}

/**
 * @param {string|number} companyId
 * @returns {import('../types').CompanyPreferences | null}
 */
export function readCompanyPreferences(companyId) {
  if (companyId == null || companyId === '') return null;
  const stored = readAllPreferences()[String(companyId)];
  if (!stored || typeof stored !== 'object') return null;
  return normalizeCompanyPreferences(stored);
}

/**
 * @param {string|number} companyId
 * @param {import('../types').CompanyPreferences} prefs
 */
export function writeCompanyPreferences(companyId, prefs) {
  if (companyId == null || companyId === '') return;
  try {
    const all = readAllPreferences();
    all[String(companyId)] = normalizeCompanyPreferences(prefs);
    localStorage.setItem(COMPANY_PREFERENCES_STORAGE_KEY, JSON.stringify(all));
  } catch {
    // Quota / private mode — cache is optional hydrate only.
  }
}
